module.exports = __webpack_public_path__ + "img/banner.c1e18549.jpg";